<template>
  <main></main>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  created() {
    let base
    if (process.env.VUE_APP_ROOT_API.toUpperCase().includes('KWS-UAT')) {
      base = 'https://parent-uat.etonhouse.com'
    } else {
      base = 'https://parent.etonhouse.com'
    }

    window.location.href = base + '/Public/OnlineWithdrawalForm'
  },
}
</script>
